import axiosClient from "../axios";
import { ResultDataModel } from "../../utility/interface/api/result-data";
import { InstanceGroupBlobReq } from "../../utility/interface/instancegroup";

// get instancegroup list
export const getInstanceGroupList = () => {
  const url = `instancegroups`;
  return axiosClient.get<ResultDataModel<any>>(url);
};

// get specific instancegroup
export const getInstanceGroup = (instancegroupId: string) => {
  const url = `instancegroups/${instancegroupId}`;
  return axiosClient.get<ResultDataModel<any>>(url);
};

export const createInstanceGroup = (
  instancegroupBlob: InstanceGroupBlobReq
) => {
  const url = `instancegroups`;
  const body = {
    ...instancegroupBlob,
  };
  return axiosClient.post<ResultDataModel<any>>(url, body);
};

// remove specific instancegroup
export const deleteInstanceGroup = (instance_group_id: string) => {
  const url = `instancegroups/${instance_group_id}`;
  return axiosClient.delete<ResultDataModel<any>>(url);
};

export const addInstanceToInstanceGroup = (
  instance_group_id: string,
  instance_ids: string[]
) => {
  const url = `instancegroups/${instance_group_id}/instances`;
  const body = {
    instance_ids: instance_ids,
  };
  return axiosClient.post<ResultDataModel<any>>(url, body);
};

export const removeInstanceFromInstanceGroup = (
  instancegroupId: any,
  instanceIdList: string
) => {
  // let fixedList = instanceIdList.join("%2C");
  const url = `instancegroups/${instancegroupId}/instances/${instanceIdList}`;
  return axiosClient.delete<ResultDataModel<any>>(url);
};
